module.exports = __webpack_public_path__ + "static/media/iphone_screen8.57f27a52.png";